<template>
  <div class="main main-really-raised w-50 ml-auto mr-auto">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card card-signup no-shadow mt-0">
            <div
              class="card-header card-header-primary negative blue-grad w-50 d-flex"
            >
              <button class="btn btn-sm btn-link" @click="$router.go(-1)">
                <i class="fa fa-chevron-left"></i> {{ $t("message.back") }}
              </button>
              <h4 class="card-title">
                {{ $t("message.admin.registrations") }}
              </h4>
            </div>
            <div class="card-body px-3">
              <!-- <router-link :to="{name: 'admin-index'}" class="btn btn-sm btn-outline-primary" >{{$t('message.back')}}</router-link> -->
              <b-table
                :items="users"
                :fields="user_fields"
                :tbody-tr-class="rowClass"
              >
                <template v-slot:cell(full_name)="data">
                  <router-link
                    target="_blank"
                    :to="{
                      name: 'user-profile-personal',
                      params: { id: data.item.org_code },
                    }"
                  >
                    {{ data.item.given_name }}
                    {{ data.item.middle_name }}
                    {{ data.item.last_name }}
                  </router-link>
                </template>
                <template v-slot:cell(org_name)="data">
                  <router-link
                    target="_blank"
                    :to="{
                      name: 'user-profile-company',
                      params: { id: data.item.org_code },
                    }"
                  >
                    {{ data.item.org_name }}
                  </router-link>
                </template>
                <template v-slot:cell(number)="data">
                  {{ data.item.email }}
                </template>
                <template v-slot:cell(active)="data">
                  <button
                    class="btn btn-sm btn-success"
                    v-if="data.item.is_accepted == 0"
                    @click="accept_user(data.item)"
                  >
                    {{ $t("message.contracts.offer_accept") }}
                  </button>
                  <button
                    class="btn btn-sm btn-danger"
                    v-if="data.item.is_accepted == 0"
                    @click="decline_user(data.item)"
                  >
                    {{ $t("message.contracts.offer_decline") }}
                  </button>
                  <div
                    class="badge badge-warning"
                    v-if="data.item.is_accepted == 1"
                  >
                    {{ $t("message.admin.registration_approved") }}
                  </div>
                  <div
                    class="badge badge-warning"
                    v-if="data.item.is_accepted == -1"
                  >
                    {{ $t("message.admin.registration_declined") }} ({{
                      data.item.declined_text
                    }})
                  </div>
                </template>
              </b-table>
              <div class="d-flex justify-content-center">
                <b-pagination
                  v-model="current_page"
                  :total-rows="users_length"
                  :per-page="per_page"
                  aria-controls="my-table"
                ></b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="decline-modal"
      :hide-footer="true"
      size="sm"
      :title="$t('message.contracts.offer_decline')"
    >
      <div class="form-group">
        <textarea
          style="height: 150px"
          class="form-control mb-2"
          v-model="declination_reason"
          :placeholder="
            $t('message.admin.registration_declination_placeholder')
          "
        ></textarea>
      </div>
      <button class="btn btn-danger" @click="send_declination_request()">
        {{ $t("message.contracts.offer_decline") }}
      </button>
    </b-modal>
  </div>
</template>
<script>
export default {
  name: "admin-registrations",
  mounted() {
    if (!this.$store.state.auth) this.$router.push({ name: "sign-in" });
    this.load();
  },
  computed: {
    // users_length(){
    //     return this.users.length
    // }
  },
  data() {
    return {
      current_page: 0,
      per_page: 20,
      users: [],

      declination_user: null,
      declination_reason: "",

      user_fields: [
        {
          key: "number",
          label: "E-mail",
          sortable: true,
        },
        {
          key: "full_name",
          label: this.$t("message.account.org_founders_person_name"),
          sortable: true,
        },
        {
          key: "org_name",
          label: this.$t("message.account.org_founders_company"),
          sortable: true,
        },
        {
          key: "country",
          label: this.$t("message.account.org_founders_country"),
          sortable: true,
        },
        {
          key: "reg_date",
          label: this.$t("message.admin.request_date"),
          sortable: true,
        },
        {
          key: "active",
          label: this.$t("message.admin.active"),
          sortable: true,
        },
      ],
    };
  },
  watch: {
    current_page() {
      this.load();
    },
  },
  methods: {
    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (item.is_email_verified === 1) return "table-success";
      if (item.is_email_verified === 0) return "table-warning";
      if (item.is_email_verified === -1) return "table-danger";
    },

    /**
     * Fetches list of all users, filters only those who is not active and
     * adds to users list
     */
    load() {
      axios
        .get(
          window.base +
            "/account/GetUnconfirmedUsers?page=" +
            (this.current_page - 1) +
            "&pageSize=" +
            this.per_page,
        )
        .then((response) => {
          this.users = response.data; //.filter(i=>i.active==0)
          this.users_length = response.data[0].total_count;
        });
    },
    /**
     * Sends request to backend to decline user registration
     */
    send_declination_request() {
      var fd = new FormData();
      fd.append("user_id", this.declination_user.user_id);
      fd.append("name", this.declination_user.given_name);
      fd.append("last_name", this.declination_user.last_name);
      fd.append("message", this.declination_reason);

      axios
        .post(window.base + "/account/DeclineUser", fd)
        .then((response) => {
          this.load();
          new Noty({
            theme: "light",
            type: "success",
            text: this.$root.$t("message.message.success"),
            timeout: 5000,
          }).show();
          this.$bvModal.hide("decline-modal");
        })
        .catch((e) => {
          this.load();
          new Noty({
            theme: "light",
            type: "error",
            text: this.$root.$t("message.message.no_success") + " (" + e + ")",
            timeout: 5000,
          }).show();
          this.$bvModal.hide("decline-modal");
        });

      // axios.post(window.base + '/account/ActivateUser', fd).then(response=>{
      //     this.load()
      //     new Noty({
      //         theme: 'light',
      //         type: 'success',
      //         text: this.$root.$t('message.message.success'),
      //         timeout: 5000,
      //     }).show();
      // }).catch(e=>{
      //     new Noty({
      //         theme: 'light',
      //         type: 'error',
      //         text: this.$root.$t('message.message.no_success')+' ('+e+')',
      //         timeout: 5000,
      //     }).show();
      // })
    },
    /**
     * @params user_id – user identifier
     * accepts user_id as a param and shows modal window to define
     * reason of user registration declination
     */
    decline_user(user) {
      this.declination_user = user;
      this.$bvModal.show("decline-modal");
    },
    /**
     * @params user_id – user identifier
     * accepts user_id as a param and sends request to the backend to
     * approve user registration
     */
    accept_user(user) {
      var fd = new FormData();
      fd.append("user_id", user.user_id);
      fd.append("name", user.given_name);
      fd.append("last_name", user.last_name);
      axios
        .post(window.base + "/account/ActivateUser", fd)
        .then((response) => {
          this.load();
          new Noty({
            theme: "light",
            type: "success",
            text: this.$root.$t("message.message.success"),
            timeout: 5000,
          }).show();
        })
        .catch((e) => {
          new Noty({
            theme: "light",
            type: "error",
            text: this.$root.$t("message.message.no_success") + " (" + e + ")",
            timeout: 5000,
          }).show();
        });
    },
  },
};
</script>
<style>
/* .page-item.active button{ */
/* background: #9c27b0 !important; */
/* color: #fff !important; */
/* } */
</style>
